import { IM_STUDENT } from '../../../utils/URL';
import { myLog } from '../../../utils/Utility';
import Client from '../../../utils/ClientVOIM';
import { RESPONSE_CONSTANT } from '../../../utils/ResponseConstant';
import { ACTION_TYPES } from '../../../utils/Constants';

/**
 * attachmentSave
 * @param {Number} visitId
 * @param {String} photo
 * @param {Function} callback
 */
// export const attachmentSave = (visitId, photo, callback) => {
//   let data = {
//     id: visitId,
//     images: photo,
//   };
//   return function (dispatch) {
//     Client.post(IM_STUDENT.ATTACHMENT_SAVE, data, true)
//       .then((response) => {
//         myLog("====attachment save response===::::", response.response);
//         callback(response);
//       })
//       .catch((error) => {
//         myLog("====attchment save error===????", error);
//       });
//   };
// };
/**
 * attachmentDelete
 * @param {Number} Id
 * @param {Function} callback
 */
export const attachmentDelete = (id, callback) => {
    return function (dispatch) {
        Client.DELETE(`${IM_STUDENT.ATTACHMENT_SAVE}/${id}`, null, true)
            .then((response) => {
                myLog('===attachment Delete response===::::', response.code);
                callback(response);
            })
            .catch((error) => {
                myLog('====Attachment delete error===????', error);
            });
    };
};
/**
 * getVisitInformation
 * @param {Number} visitId
 * @param {Function} callBack
 */
export function getVisitInformation(id, callBack) {
    return (dispatch) => {
        Client.get(`${IM_STUDENT.GET_VISIT_INFORMATON}${id}`, null, true)
            .then((response) => {
                myLog(
                    '====getVisitInformation Action response===::::',
                    response.response.activeVisitSession
                );
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.PATIENT.GET_VISIT_INFORMATION,
                        payload: response.response,
                    });
                    // Dispatch whiteboard state from server response
                    const whiteboardResVO = response.response?.whiteboardResVO;
                    if (whiteboardResVO) {
                        dispatch({
                            type: ACTION_TYPES.WHITE_BOARD_OPEN,
                            payload: {
                                isWhiteboardOpen: whiteboardResVO.isWhiteboardOpen || false,
                                sessionType: response.response?.sessionType || '',
                            },
                        });
                    }
                }
            })
            .catch((error) => {
                myLog('====getVisitInformation error===????', error);
                callBack(false);
            });
    };
}
/**
 * visitEnter
 * @param {Number} visitId
 * @param {Number} isVisitCredit
 * @param {Function} callBack
 */
export function visitEnter(id, callBack) {
    return (dispatch) => {
        Client.put(`${IM_STUDENT.ENTER_ROOM}/${id}/join`, null, true)
            .then((response) => {
                myLog('====Enter Room Action response===::::', response);
                callBack(response);
            })
            .catch((error) => {
                myLog('====Enter Room error===????', error);
                callBack(false);
            });
    };
}

/**
 * getResumeSession
 * @param {Number} visitId
 * @param {Function} callBack
 */
export function getResumeSession(id, callBack) {
    return () => {
        Client.get(`${IM_STUDENT.GET_VISIT_INFORMATON}${id}/resume`, null, true)
            .then((response) => {
                myLog('====getVisitInformation Action response===::::', response);
                callBack(response);
            })
            .catch((error) => {
                callBack(false);
            });
    };
}

/**
 * getSessionChatSummary
 * @param {Number} visitId
 * @param {Function} callBack
 */
export const getSessionSummaryChatWithPagination = (visitId, values, callback) => {
    return (dispatch) => {
        Client.getV2(`${IM_STUDENT.GET_VISIT_INFORMATON}/${visitId}/chat`, values, true)
            .then((response) => {
                myLog('====getSessionSummaryChatWithPagination ===::::response', response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    callback(response);
                }
            })
            .catch((error) => {
                myLog('====getSessionSummaryChatWithPagination ==?????error', error);
                callback(false);
            });
    };
};
